<template>
  <div class="receiptBaseInfo">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :disabled="!canEdit"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  // import DataBaseAPI from '@/api/dataBase';

  export default {
    name: 'basicInfo',
    components: {
      baseForm,
    },
    props: ['canEdit'],
    data() {
      return {
        baseData: {
          id: null,
          accountCode: null, // 科目代码
          accountDesc: null, // 科目描述
          isAvailable: null, // 状态
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            // 科目代码
            type: 'input',
            label: this.$t('financeAccount.column.accountCode'),
            prop: 'accountCode',
            disabled: this.baseData.id,
          },
          {
            // 科目描述
            type: 'input',
            label: this.$t('financeAccount.column.accountDesc'),
            prop: 'accountDesc',
            required: true,
          },
          {
            // 状态
            type: 'dict',
            dictType: 'financeAccountStatus',
            label: this.$t('financeAccount.column.isAvailable'),
            prop: 'isAvailable',
            placeholder: this.$t('financeAccount.column.auto'),
            disabled: true,
          },
        ];
      },
    },
    mounted() {},
    methods: {
      handleChangeBaseData(value, prop) {
        //基本数据表单变化
        console.log(value, prop);
      },
      exportChildData() {
        // 返回数据
        // 点击提交，走校验
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
